module.exports = __webpack_public_path__ + "static/media/verdeBaby_wide.3b607dc0.jpg";